import { elevationMap, type ThemeElevation } from '../elevation.ts'

const getElevationClassName = (elevation?: ThemeElevation) => {
  return elevation ? elevationMap[elevation] : ''
}

export { getElevationClassName }
